/**
 * OZN Search Relevance — OPZIONE C: "garment in q + colore come filtro nativo"
 * -----------------------------------------------------------------------------
 * Obiettivo: replicare la logica della tendina predittiva (tipo + colore) usando
 * i filtri storefront di Shopify invece di AND o re-rank client-side.
 *
 * Esempio: "abito ocra" ->
 *   /search?q=abito&filter.v.option.colore=Ocra&options[prefix]=last
 *
 * L'input di ricerca mostra solo q (search.terms); i filtri colore restano
 * nella sidebar. Un nuovo invio resetta i filtri precedenti (solo Option C
 * puo' aggiungere un colore se e' scritto nella query, es. "abito ocra").
 *
 * Il vocabolario colori viene da search.filters (snippet JSON + Section API).
 * Solo suffissi che matchano un valore colore del catalogo vengono separati;
 * "pantalone rigato vicolo" resta invariato (vicolo non e' un colore).
 */
(function () {
  'use strict';

  var CACHE_KEY = 'ozn:search-color-config';
  var CACHE_TTL = 60 * 60 * 1000;
  var SECTION_ID = 'ozn-search-color-data';
  var COLOR_PARAM_FALLBACK = 'filter.v.option.colore';
  var configPromise = null;

  function norm(str) {
    return (str || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isSearchResultsPage() {
    return window.location.pathname.indexOf('/search') !== -1;
  }

  function parseConfigFromDoc(doc) {
    var node = doc.getElementById('ozn-search-color-data');
    if (!node || !node.textContent) return null;
    try {
      var data = JSON.parse(node.textContent);
      if (!data || !data.colors || !data.colors.length) return null;
      return {
        paramName: data.paramName || COLOR_PARAM_FALLBACK,
        colors: data.colors
      };
    } catch (e) {
      return null;
    }
  }

  function readCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var entry = JSON.parse(raw);
      if (!entry || Date.now() - (entry.ts || 0) > CACHE_TTL) return null;
      return entry.data;
    } catch (e) {
      return null;
    }
  }

  function writeCache(data) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), data: data }));
    } catch (e) {
      /* storage unavailable */
    }
  }

  function fetchColorConfig() {
    if (configPromise) return configPromise;

    configPromise = new Promise(function (resolve) {
      var inline = parseConfigFromDoc(document);
      if (inline) {
        writeCache(inline);
        resolve(inline);
        return;
      }

      var cached = readCache();
      if (cached) {
        resolve(cached);
        return;
      }

      fetch('/search?q=a&section_id=' + encodeURIComponent(SECTION_ID), {
        credentials: 'same-origin'
      })
        .then(function (res) {
          return res.ok ? res.text() : Promise.reject(res.status);
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var data = parseConfigFromDoc(doc);
          if (data) writeCache(data);
          resolve(data || { paramName: COLOR_PARAM_FALLBACK, colors: [] });
        })
        .catch(function () {
          resolve({ paramName: COLOR_PARAM_FALLBACK, colors: [] });
        });
    });

    return configPromise;
  }

  // Prefetch cosi' il primo invio dal header e' immediato.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      fetchColorConfig();
    });
  } else {
    fetchColorConfig();
  }

  function findColorSplit(rawQuery, colors) {
    var tokens = (rawQuery || '').trim().split(/\s+/).filter(Boolean);
    if (tokens.length < 2 || !colors.length) return null;

    var sorted = colors.slice().sort(function (a, b) {
      return norm(b.label).length - norm(a.label);
    });

    var i;
    var c;
    var cl;
    var cWords;
    var suffix;
    var garment;

    for (i = 0; i < sorted.length; i++) {
      c = sorted[i];
      cl = norm(c.label);
      if (!cl) continue;
      cWords = cl.split(/\s+/).filter(Boolean);
      if (cWords.length >= tokens.length) continue;

      suffix = norm(tokens.slice(-cWords.length).join(' '));
      if (suffix !== cl && suffix !== norm(c.value)) continue;

      garment = tokens.slice(0, -cWords.length);
      if (!garment.length) return null;

      return {
        garmentQuery: garment.join(' '),
        color: c
      };
    }

    return null;
  }

  function normSearchQ(q) {
    return norm((q || '').replace(/\*/g, ' '));
  }

  function searchSignatureFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var parts = [normSearchQ(params.get('q'))];
    var filters = [];
    params.forEach(function (v, k) {
      if (k.indexOf('filter.') === 0) filters.push(k + '=' + norm(v));
    });
    filters.sort();
    parts = parts.concat(filters);
    var sort = params.get('sort_by');
    if (sort) parts.push('sort_by=' + norm(sort));
    return parts.join('|');
  }

  function normalizeSearchSignature(sig) {
    return norm(sig || '');
  }

  function getDomSearchSignature() {
    var el = document.querySelector('#CollectionAjaxContent .ozn-search-state');
    return el ? el.getAttribute('data-ozn-search-sig') : null;
  }

  function validateSearchPageFreshness() {
    if (!isSearchResultsPage() || window.__oznGridReloaded) return false;
    var domSig = getDomSearchSignature();
    if (!domSig) return false;
    var urlSig = searchSignatureFromUrl();
    if (normalizeSearchSignature(domSig) === normalizeSearchSignature(urlSig)) {
      try {
        sessionStorage.removeItem('ozn:search-reload-attempt');
      } catch (e) {
        /* storage unavailable */
      }
      return false;
    }
    try {
      var attempts = parseInt(sessionStorage.getItem('ozn:search-reload-attempt') || '0', 10);
      if (attempts >= 2) return false;
      sessionStorage.setItem('ozn:search-reload-attempt', String(attempts + 1));
    } catch (e) {
      /* storage unavailable */
    }
    window.__oznGridReloaded = true;
    var params = new URLSearchParams(window.location.search);
    params.set('_oznc', String(Date.now()));
    window.location.replace(window.location.pathname + '?' + params.toString());
    return true;
  }

  function clearAutofillScrollState() {
    try {
      sessionStorage.removeItem('ozn:collection-scroll');
    } catch (e) {
      /* storage unavailable */
    }
  }

  function stripSearchCacheBustParam() {
    var params = new URLSearchParams(window.location.search);
    if (!params.has('_oznc')) return;
    params.delete('_oznc');
    var qs = params.toString();
    history.replaceState({}, '', window.location.pathname + (qs ? '?' + qs : ''));
  }

  function buildSearchNavigateParams(form, raw, config) {
    var params = new URLSearchParams();
    var split = findColorSplit(raw, config.colors);
    var prefixInput = form.querySelector('input[name="options[prefix]"]');

    // Fresh search: drop previous sidebar filters / sort. Only carry prefix + q,
    // plus Option C color when the typed query itself ends with a color name.
    params.set('options[prefix]', prefixInput ? prefixInput.value : 'last');

    if (split) {
      params.set('q', split.garmentQuery);
      params.set(config.paramName || COLOR_PARAM_FALLBACK, split.color.value);
    } else {
      params.set('q', raw);
    }

    return params;
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;

      var action = form.getAttribute('action') || '';
      if (action.indexOf('/search') === -1) return;

      var input = form.querySelector('input[type="search"], input[name="q"]');
      if (!input) return;

      var raw = (input.value || '').trim();
      if (!raw) return;

      e.preventDefault();
      e.stopPropagation();

      window.__oznNavigatingSearch = true;

      try {
        sessionStorage.removeItem('ozn:collection-scroll');
        sessionStorage.removeItem('ozn:search-reload-attempt');
      } catch (err) {
        /* storage unavailable */
      }

      fetchColorConfig().then(function (config) {
        var params = buildSearchNavigateParams(form, raw, config);

        var base = action.split('?')[0];
        params.set('_oznc', String(Date.now()));
        window.location.replace(base + '?' + params.toString());
      });
    },
    true
  );

  function initSearchPageGuards() {
    if (!isSearchResultsPage()) return;
    if (validateSearchPageFreshness()) return;
    clearAutofillScrollState();
    stripSearchCacheBustParam();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.__oznNavigatingSearch = false;
      initSearchPageGuards();
    });
  } else {
    window.__oznNavigatingSearch = false;
    initSearchPageGuards();
  }

  window.addEventListener('pageshow', function () {
    if (!isSearchResultsPage()) return;
    validateSearchPageFreshness();
  });
})();
